import type { ReactElement } from "react";
import { useUser } from "../auth";

interface Props {
    children: ReactElement;
}

/**
 * Hides a page from temporary users (admins using "view as company").
 */
export const NonTemporaryUserGate = ({ children }: Props) => {
    const isTemporaryUser = useUser().isTemporaryUser;

    if (isTemporaryUser) {
        return null;
    }

    return children;
};
